import { IBlogCard } from "../pages/MyWSG/Cards/Blog";
import Axios from "../utils/axios";

const axios = new Axios();

export interface BlogApiResponse {
  data: IBlogCard[];
  count?: number;
}

export const getBlogs = async (): Promise<IBlogCard[]> => {
  try {
    const response = await axios.Get("/blog");

    // Check if response has data property or if it's the array directly
    const blogData = response.data || response;

    return Array.isArray(blogData) ? blogData : [];
  } catch (error) {
    console.error("Error fetching blogs:", error);
    return [];
  }
};

export const getBlogsByAuthorName = async (args: {
  firstName?: string;
  lastName?: string;
  limit?: number;
}): Promise<IBlogCard[]> => {
  const terms = [args.firstName, args.lastName]
    .map((t) => String(t ?? "").trim())
    .filter(Boolean);
  if (terms.length === 0) {
    return [];
  }

  const limit = args.limit ?? 8;

  try {
    const params = new URLSearchParams();
    params.append(
      "filter",
      JSON.stringify({
        author: { value: terms, comparisonType: "CONTAINS_ANY" },
        isDeleted: { value: false, comparisonType: "EQUAL" },
      }),
    );
    params.append(
      "sort",
      JSON.stringify({ field: "dateCreated", order: "desc" }),
    );
    params.append(
      "pagination",
      JSON.stringify({ pageIndex: 0, pageSize: limit }),
    );

    const response = await axios.Get(`/blog?${params.toString()}`);
    const blogData = response.data || response;
    return Array.isArray(blogData) ? blogData : [];
  } catch (error) {
    console.error("Error fetching blogs by author:", error);
    return [];
  }
};
